module.exports = __webpack_public_path__ + "img/dataset_class.397f8bf5.png";